import { render, staticRenderFns } from "./TabEconomic.vue?vue&type=template&id=064979db&"
import script from "./TabEconomic.vue?vue&type=script&lang=js&"
export * from "./TabEconomic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports